export default () => ({
  show: false,
  close() {
    this.show = false;
    Grebify.noScroll(false);
  },
  open() {
    this.show = true;
    Grebify.noScroll(true);
  },
  toggle() {
    console.log("inventortyToggle");
    this.show = !this.show;
    Grebify.noScroll(!this.show);
  },
});
